var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWithFriends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400.000000pt",
    height: "400.000000pt",
    viewBox: "0 0 400.000000 400.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,400.000000) scale(0.100000,-0.100000)",
    fill: "#c4c4c4",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1940 3989 c-50 -10 -29 9 -598 -554 -167 -165 -310 -312 -318 -327 -21 -40 -18 -156 5 -210 34 -80 151 -144 240 -132 43 6 62 19 251 185 113 98 213 178 223 179 16 0 17 -47 17 -847 l0 -848 24 -51 c22 -47 61 -86 111 -112 11 -5 58 -13 105 -16 l85 -7 63 56 c34 32 68 67 75 79 9 16 13 227 17 886 5 808 6 865 22 868 11 2 83 -59 204 -175 l186 -178 96 -12 97 -13 66 66 66 66 7 88 c5 66 3 98 -7 122 -15 35 -860 866 -894 879 -37 13 -99 17 -143 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 3731 c-219 -22 -390 -144 -493 -350 l-37 -75 0 -1432 0 -1432 55 -109 c83 -163 168 -234 368 -309 l62 -24 1515 0 1515 0 117 47 c84 34 130 58 162 87 54 50 141 166 175 235 l26 50 0 1398 c0 1390 0 1399 -21 1490 -18 78 -30 105 -78 175 -109 160 -272 240 -518 253 l-122 6 -64 -43 c-86 -57 -107 -98 -107 -208 0 -78 1 -81 36 -120 65 -72 113 -96 216 -109 112 -15 153 -36 168 -89 6 -24 10 -478 10 -1328 l0 -1290 -36 -42 -36 -42 -1442 0 -1443 0 -37 47 -36 46 0 1299 0 1300 36 44 36 44 77 0 c85 0 147 14 175 38 10 10 41 46 67 81 l49 64 0 89 c0 99 4 92 -98 176 -41 34 -46 35 -135 37 -50 2 -123 0 -162 -4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWithFriends);
export default __webpack_public_path__ + "static/media/share-with-friends.a1c521c12bcdc84a35ef66a410aaec3c.svg";
export { ForwardRef as ReactComponent };